import { Box, Paper } from "@mui/material";
import React, { useMemo, useEffect } from "react";
import LeadsGlobalSearch from "../../components/GlobalSearch/LeadsGlobalSearch";
import { useLocation } from "react-router-dom";
import TasksGlobalSearch from "../../components/GlobalSearch/TasksGlobalSearch";
import ContactsGlobalSearch from "../../components/GlobalSearch/ContactsGlobalSearch";
import NotesGlobalSearch from "../../components/GlobalSearch/NotesGlobalSearch";
import CampaignsGlobalSearch from "../../components/GlobalSearch/CampaignsGlobalSearch";
import DealsGlobalSearch from "../../components/GlobalSearch/DealsGlobalSearch";
import AccountsGlobalSearch from "../../components/GlobalSearch/AccountsGlobalSearch";

const GlobalSearch = () => {
    const location = useLocation();

    const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
    const module = queryParams.get("module")?.toLowerCase() || "all";
    const searchValue = queryParams.get("searchValue") || "";

    useEffect(() => {
        document.title = "Search Results - iLead CRM";
    }, [])

    const renderModuleComponent = () => {
        if (module === "all") {
            return (
                <>
                    <Paper sx={{ p: 2, mb: 2 }}>
                        <h3>Lead Results</h3>
                        <LeadsGlobalSearch globalSearchValue={searchValue} />
                    </Paper>
                    <Paper sx={{ p: 2, mb: 2 }}>
                        <h3>Contacts Results</h3>
                        <ContactsGlobalSearch globalSearchValue={searchValue} />
                    </Paper>
                    <Paper sx={{ p: 2, mb: 2 }}>
                        <h3>Accounts Results</h3>
                        <AccountsGlobalSearch globalSearchValue={searchValue} />
                    </Paper>
                    <Paper sx={{ p: 2, mb: 2 }}>
                        <h3>Tasks Results</h3>
                        <TasksGlobalSearch globalSearchValue={searchValue} />
                    </Paper>
                    <Paper sx={{ p: 2, mb: 2 }}>
                        <h3>Notes Results</h3>
                        <NotesGlobalSearch globalSearchValue={searchValue} />
                    </Paper>
                    <Paper sx={{ p: 2, mb: 2 }}>
                        <h3>Campaigns Results</h3>
                        <CampaignsGlobalSearch globalSearchValue={searchValue} />
                    </Paper>
                    <Paper sx={{ p: 2, mb: 2 }}>
                        <h3>Deals Results</h3>
                        <DealsGlobalSearch globalSearchValue={searchValue} />
                    </Paper>
                </>
            );
        }

        switch (module) {
            case "leads":
                return <Paper sx={{ p: 2 }}><h3>Lead Results</h3><LeadsGlobalSearch globalSearchValue={searchValue} /></Paper>;
            case "contacts":
                return <Paper sx={{ p: 2 }}><h3>Contacts Results</h3><ContactsGlobalSearch globalSearchValue={searchValue} /></Paper>;
            case "tasks":
                return <Paper sx={{ p: 2 }}><h3>Tasks Results</h3><TasksGlobalSearch globalSearchValue={searchValue} /></Paper>;
            case "notes":
                return <Paper sx={{ p: 2 }}><h3>Notes Results</h3><NotesGlobalSearch globalSearchValue={searchValue} /></Paper>;
            case "campaigns":
                return <Paper sx={{ p: 2 }}><h3>Campaigns Results</h3><CampaignsGlobalSearch globalSearchValue={searchValue} /></Paper>;
            case "deals":
                return <Paper sx={{ p: 2 }}><h3>Deals Results</h3><DealsGlobalSearch globalSearchValue={searchValue} /></Paper>;
            case "accounts":
                return <Paper sx={{ p: 2 }}><h3>Accounts Results</h3><AccountsGlobalSearch globalSearchValue={searchValue} /></Paper>;

            default:
                return <p>Please select a module to search.</p>;
        }
    };

    return (
        <>
            <Box sx={{ paddingX: 2, pt: 2 }}>
                <Box sx={{ p: 2 }}>
                    <h2>Search Results</h2>
                    {renderModuleComponent()}
                </Box>
            </Box>
        </>
    )
}

export default GlobalSearch;